import { render, staticRenderFns } from "./OpenButton.vue?vue&type=template&id=dd148c82&scoped=true"
import script from "./OpenButton.vue?vue&type=script&lang=js"
export * from "./OpenButton.vue?vue&type=script&lang=js"
import style0 from "./OpenButton.vue?vue&type=style&index=0&id=dd148c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd148c82",
  null
  
)

export default component.exports